module.exports = __webpack_public_path__ + "media/images/pic/teachers/miho-takahashi-ee90665022f3e56a9a8669710b099779.png";